import { TechnologiesModule } from '@/core/modules/digital-footprint/technologies/technologies.module'
import { AppModule } from '@core/modules/app/app.module'
import { clsx } from 'clsx'
import { LoaderWithText } from '../../loader-with-text'
import './index.scss'

interface Props {
    name: string
    children?: TChildren
    skeleton?: TChildren
    pageActions?: TChildren
    loading?: boolean
    hideScanInProgress?: boolean
}

const DashboardPage = ({
    name,
    children,
    pageActions,
    loading,
    skeleton,
    hideScanInProgress = false,
}: Props) => {
    const { scanInProgress } = AppModule.useStore()
    const { addingTechnologiesProgress } = TechnologiesModule.useStore()
    const isJobInProgress = scanInProgress || addingTechnologiesProgress
    const loadingText = scanInProgress
        ? 'Scan in progress'
        : addingTechnologiesProgress
          ? 'Adding technologies'
          : ''

    return (
        <div
            className={clsx(['dashboard-page', name, loading && 'is-loading'])}
            data-testid={name}
        >
            <>
                {loading && skeleton}
                <section className="page-actions">
                    {isJobInProgress && !hideScanInProgress ? (
                        <LoaderWithText text={loadingText} />
                    ) : (
                        !loading && pageActions
                    )}
                </section>
                {!loading && (
                    <section className="page-content">{children}</section>
                )}
            </>
        </div>
    )
}

export default DashboardPage
